export const MONTHLY = 'monthly';
export const ANNUAL = 'annual';
